(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.filereader
   * @description
   *
   */
  angular
    .module('utils.filereader', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
